"use client";

export default function ComingSoon() {
  return <section id="coming-soon" className="bg-background py-24 md:py-32 lg:py-40">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          {}
          <h1 className="font-default font-bold text-4xl sm:text-5xl lg:text-6xl text-foreground mb-6 tracking-tight">
            Coming Soon
          </h1>

          {}
          <div className="w-16 h-1 bg-primary mx-auto mb-8" />

          {}
          <p className="font-default text-lg sm:text-xl text-foreground/90 leading-relaxed mb-8">
            Our upcoming calendar of events and experiences will be launching soon. Trust us—you're going to want to be part of this.
          </p>

          {}
          <div className="flex justify-center gap-4">
            <button type="button" onClick={() => {
            alert("Thank you for your interest! We'll notify you when events are available.");
          }} className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 bg-green-accent text-primary-foreground shadow-xs hover:bg-green-accent/90 h-9 px-4 py-2">
              Notify Me
            </button>
          </div>

          {}
          <p className="font-default text-sm text-foreground/70 mt-12">
            Stay tuned for exclusive events, wellness retreats, and unforgettable experiences.
          </p>
        </div>
      </div>
    </section>;
}